import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ACCOUNT_TYPE_CORPORATE_CORPORATE,
  ACCOUNT_TYPE_CORPORATE_LLC,
  ACCOUNT_TYPE_CORPORATE_PARTNERSHIP,
  ACCOUNT_TYPE_CORPORATE_SOLE_PROPRIETORSHIP,
} from '../../constants/accountTypes';
import { useAccountData } from '../../hooks/useAccountData';
import useBusinessTypeDispatch from '../../hooks/useBusinessTypeDispatch';
import useStepPost from '../../hooks/useStepPost';
import SelectList from '../SelectList/SelectList';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';
import { ACCOUNT_TYPE_GTM } from '../../constants/sessionStorage';

const BusinessTypeForm = ({ nextPath, onModalClose }) => {
  const { onSuccess } = useStepPost({ nextPath, onModalClose });
  const AccountData = useAccountData();
  const { t } = useTranslation();
  const { businessTypeDispatch } = useBusinessTypeDispatch();

  const { gtmStepEvent } = useGtmStepHook();
  const accountGtmType = retrieveFromSessionStorage(ACCOUNT_TYPE_GTM);

  useEffect(() => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'Verify Business Type',
      accountType: accountGtmType,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'Verify Business Type',
      accountType: accountGtmType,
    });
  };

  const submitData = (type) => {
    handleGtmEvent();
    businessTypeDispatch({
      data: {
        CorporateAccountType: type,
      },
      onSuccess,
      shouldUpdate: AccountData?.AccountType,
    });
  };

  const options = () => [
    {
      title: t('selectPath.options.standard.business.llc'),
      onClick: () => submitData(ACCOUNT_TYPE_CORPORATE_LLC),
      dataCy: 'button-llc',
    },
    {
      title: t('selectPath.options.standard.business.corp'),
      onClick: () => submitData(ACCOUNT_TYPE_CORPORATE_CORPORATE),
      dataCy: 'button-c-s-corp',
    },
    {
      title: t('selectPath.options.standard.business.partnership'),
      onClick: () => submitData(ACCOUNT_TYPE_CORPORATE_PARTNERSHIP),
      dataCy: 'button-lllp',
    },
    {
      title: t('selectPath.options.standard.business.sole'),
      onClick: () => submitData(ACCOUNT_TYPE_CORPORATE_SOLE_PROPRIETORSHIP),
      showDivider: false,
      dataCy: 'button-sp',
    },
  ];

  return <SelectList options={options()} onlyTitle titleWeight={400} />;
};

BusinessTypeForm.propTypes = {
  nextPath: PropTypes.string,
  onModalClose: PropTypes.func,
};

export default BusinessTypeForm;
